module.exports = __webpack_public_path__ + "1caa746fa8e696fdc7640350446cfa28.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Facebook_20x20.svg
// module id = 154
// module chunks = 0